import { Route } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { JhiTrackerComponent } from './tracker.component';
import { JhiTrackerService, Principal } from '../../shared';

export const trackerRoute: Route = {
    path: 'jhi-tracker',
    component: JhiTrackerComponent,
    data: {
        pageTitle: 'tracker.title'
    }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/tracker/tracker.route.ts